<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>training Videos</h1>
    </div>

    <div class="container">
      <br><br>
      <!-- No Trainings -->
      <div class="col-xs-12 text-center" v-if="availableTrainings.length === 0">
        <h1 class="text-uppercase">There are no trainings available</h1>
        <br><br>
      </div>
      <div
        v-for="(training) in availableTrainings" :key="training._id"
      >
        <div class="grey-outline-nh">
          <div class="module-list-item">
            <div class="col-sm-6 module-list-content-wrapper">
              <!-- <img :src="videoImageUrl(training.videoUrl)" class="img-responsive hidden-xs"> -->
              <img src="../../assets/images/rewards/video-ph.jpg" class="img-responsive">
            </div>
            <div class="col-sm-6 module-list-content-wrapper">
              <div class="module-list-item-content-right">
                <h2 class="text-uppercase">{{ training.moduleName }}</h2>
                <p class="module-list-item-content-description">{{ training.description }}</p>
                <router-link
                  :to="{ name: 'TrainingModule', params: { training: training } }"
                  type="button"
                  class="btn client-btn-primary btn-lg btn-block text-uppercase"
                >
                  Watch Video
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <br><br>
      </div><!-- purple-outline -->
      <br><br>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  name: 'TrainingCatalog',
  mounted () {
    Promise.all([
      this.getLoyaltyProgramBySlug(this.$store.state.slug),
      this.getUser()
    ])
  },
  computed: {
    ...mapGetters('loyaltyProgram', ['trainings']),
    ...mapState('user', {
      completedTrainings: state => state.user.userLoyaltyProgram.completedTrainings
    }),
    availableTrainings () {
      return this.trainings.filter(training => (!this.completedTrainings.find(t => t.trainingId === training._id) && !training.disabled))
    }
  },
  methods: {
    ...mapActions('loyaltyProgram', [ 'getLoyaltyProgramBySlug' ]),
    ...mapActions('user', [ 'getUser' ]),
    videoImageUrl (url) {
      if (!url) return '../../assets/images/rewards/video-ph.jpg'
      if (url.match(/youtu/gi)) {
        const vidId = url.split('/').slice(-1)[0]
        return `http://img.youtube.com/vi/${vidId}/0.jpg`
      } else {
        // this will break since the template is rendered already - the asset won't be found
        return '../../assets/images/rewards/video-ph.jpg'
      }
    }
  }
}
</script>

<style scoped>
.module-list-item {
  height: 293px;
}

.module-list-content-wrapper {
  height: 100%;
}

@media screen and (max-width: 687px) {
  .module-list-item {
    height: auto;
  }
}

.module-list-item-content-right {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.module-list-item-content-description {
  flex-grow: 1;
}
</style>
